<template>
  <v-menu :close-on-content-click="false" left nudge-width="320" max-width="320" :nudge-bottom="10" offset-y transition="slide-y-transition">
    <template v-slot:activator="{on, attrs}">
      <v-btn v-bind="attrs" v-on="on" min-width="34" max-width="34" color="secondary" outlined retain-focus-on-click><v-icon color="secondary" size="18">mdi-cog</v-icon></v-btn>
    </template>
    <v-card class="pa-0">
      <v-toolbar color="background" flat height="36">
        <v-toolbar-title class="body-2 text--secondary font-weight-medium">Contenido visible</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="py-0">
        <v-list-item class="pl-0" v-for="c in columns" :key="c.id">
          <v-list-item-title>{{ $t(c.id) }}</v-list-item-title>
          <v-list-item-action>
            <v-switch @change="toggleHeaders(c.id)" :input-value="c.display" hide-details />
          </v-list-item-action>
        </v-list-item>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    resource: {
      type: String,
      required: true
    }
  },
  computed: mapState({
    columns (state) {
      return state.ui[`${this.resource}ToggleHeaders`]
    }
  }),
  methods: {
    toggleHeaders (columnId) {
      /**
       * Set the custom header (or column) if it is visible for the table using the store
       * @param columnId String It is column id, property must be defined in state with which you are working
       */
      this.$store.dispatch('ui/TOGGLE_HEADERS', {
        resource: this.resource,
        columnId: columnId
      })
    }
  }
}
</script>